import {
  FORGOTTEN_PASSWORD_RESET_BEGIN,
  FORGOTTEN_PASSWORD_RESET_FAILURE,
  FORGOTTEN_PASSWORD_RESET_SUCCESS,
} from "../actions/forgottenpasswordactions";

const initialState = {
  loading: false,
};

export function forgottenPasswordResetReducer(state = initialState, action) {
  const nextState = Object.assign({}, state);

  switch (action.type) {
    case FORGOTTEN_PASSWORD_RESET_BEGIN:
      nextState.loading = true;
      return nextState;
    case FORGOTTEN_PASSWORD_RESET_FAILURE:
      nextState.loading = false;
      return nextState;
    case FORGOTTEN_PASSWORD_RESET_SUCCESS:
      nextState.loading = false;
      return nextState;
    default:
      return state;
  }
}
